import styled from 'styled-components';
import {ReactComponent as SignOutIconSvg} from '../../assets/icons/sign-out-alt-solid.svg';
import { SvgStyles } from './SvgStyles';

export const ExitIcon = styled(SignOutIconSvg)`
  ${(props) => SvgStyles(props)};
`;